import React, { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import { showToast } from "../../services/toastService";
import { useNavigate } from "react-router-dom";

function PaymentFinal({ billingInfo, cartItems, totalPrice }) {
  const [paymentMethod, setPaymentMethod] = useState("cashOnDelivery"); // Default payment method
  const [cartData, setcartData] = useState(cartItems);
  const [carttotalPrice, setcarttotalPrice] = useState(totalPrice);
  const { userData} = useContext(AuthContext);
  // const usersBaseURL = process.env.USER_API_URL;
  // const ordersBaseURL = process.env.ORDER_API_URL;

  const navigate = useNavigate();
  const notifySuccess = (message) => {
    showToast(message, "dark");
  };
  const notifyError = (message) => {
    showToast(message, "warn");
  };

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const [formData, setFormData] = useState({
    cardNumber: "",
    expiryDate: "",
    cvv: "",
  });

  // Function to handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const orderData = {
        userDetails: {
          id: userData.id,
          name: userData.name,
          email: userData.email
        },
        productsData: cartItems.map(item => ({
          id: item.id,
          Title:item.title,
          image:item.featuredImage.url,
          quantity: item.selectedQuantity,
          Size: item.selectedSize,
          totalPrice: item.totalValue
        })),
        paymentMethod: paymentMethod,
        totalItems: cartItems.length,
        totalPrice: totalPrice,
        status: 'pending',
        orderDate: new Date().toISOString(),
        AddressDetails: {
          fullName: billingInfo.fullName ,
          area: billingInfo.area ,
          houseNumber: billingInfo.houseNumber,
          pinCode: billingInfo.pinCode,
          city: billingInfo.city ,
          email: billingInfo.email 
        }
      };
      

      try {
        // Make POST request to store the order
        // const response = await axios.post('http://localhost:3001/orders', orderData);
        const response = await axios.post('https://ecommerce-user-api.onrender.com/orders', orderData);
        // const response = await axios.post(ordersBaseURL, orderData);
  
        // Handle success response
        console.log('Order placed successfully:', response.data);
        addUserMyorders(response)
        // You can redirect to a confirmation page or perform any other actions here
      } catch (error) {
        // Handle error
        console.error('Error placing order:', error);
        notifyError('Error placing order')
      }

    console.log(formData); // Output form data to console
    // You can perform additional actions like sending data to a server here
  };
 
  const addUserMyorders = async(response) => {

    try {

        const orderId = response.data.id;
        const updatedUser = {
          ...userData,
          myOrders: [...userData.myOrders, orderId]
        };
        
        // Make PATCH request to update user's myOrders array
        // await axios.patch(`http://localhost:3001/users/${userData.id}`, { myOrders: updatedUser.myOrders });
        await axios.patch(`https://ecommerce-user-api.onrender.com/users/${userData.id}`, { myOrders: updatedUser.myOrders });
        // await axios.patch(`${usersBaseURL}/${userData.id}`, { myOrders: updatedUser.myOrders });
        notifySuccess('Order placed successfully')
        

        navigate(`/profile`);
    
        // You can redirect to a confirmation page or perform any other actions here
      } catch (error) {
        // Handle error
        console.error('Error placing order:', error);
        notifyError('Error placing order');
        navigate(`/checkout`);
      }

  }
  return (
    <div className="gap-2 grid grid-cols-1 md:grid-cols-2 border">
      <div className="first-container">
        <div className="space-y-1 bg-white p-4 border-b font-primaryFont capitalize">
          <h2 className="mb-2 font-semibold text-lg">Delivery Address:</h2>
          <p>
            <strong>Name:</strong> {billingInfo?.fullName}
          </p>
          <p>
            <strong>Email:</strong> {billingInfo?.email}
          </p>
          <p>
            <strong>House Number:</strong> {billingInfo?.houseNumber}
          </p>
          <p>
            <strong>Area:</strong> {billingInfo?.area}
          </p>
          <p>
            <strong>City:</strong> {billingInfo?.city}
          </p>
          <p>
            <strong>Pin Code:</strong> {billingInfo?.pinCode}
          </p>
        </div>

        <div className="space-y-4 mt-4 p-4">
          <h1 className="font-semibold text-xl">Select Payment Method:</h1>
          <div className="flex flex-wrap justify-start items-start gap-4 w-full font-primaryFont text-sm payment-method-container">
            <div className="flex items-center gap-1">
              <input
                type="radio"
                id="cashOnDelivery"
                name="paymentMethod"
                value="cashOnDelivery"
                checked={paymentMethod === "cashOnDelivery"}
                onChange={handlePaymentMethodChange}
                className=""
              />
              <label
                htmlFor="cashOnDelivery"
                className={`${
                  paymentMethod === "cashOnDelivery"
                    ? "bg-black text-white"
                    : ""
                }bg-primary p-2 flex gap-2 items-center rounded font-semibold  cursor-pointer text-white`}
              >
                {" "}
                <img
                  className="bg-white rounded-full w-10"
                  src="/assets/Payment/pngwing.com (3).png"
                  alt=""
                />
                Cash on Delivery
              </label>
            </div>

            <div className="flex items-center gap-1">
              <input
                type="radio"
                id="creditCard"
                name="paymentMethod"
                value="creditCard"
                checked={paymentMethod === "creditCard"}
                onChange={handlePaymentMethodChange}
                className=""
              />
              <label
                htmlFor="creditCard"
                className={`${
                  paymentMethod === "creditCard" ? "bg-black text-white" : ""
                }bg-primary p-2 flex gap-2 items-center rounded font-semibold  cursor-pointer text-white`}
              >
                {" "}
                <img
                  className="bg-white rounded-full w-10 object-contain"
                  src="/assets/Payment/pngwing.com (2).png"
                  alt=""
                />
                Credit Card
              </label>
            </div>
            <div className="flex items-center gap-1">
              <input
                type="radio"
                id="gpay"
                name="paymentMethod"
                value="gpay"
                checked={paymentMethod === "gpay"}
                onChange={handlePaymentMethodChange}
                className=""
              />
              <label
                htmlFor="gpay"
                className={`${
                  paymentMethod === "gpay" ? "bg-black text-white" : ""
                }bg-primary p-2 flex gap-2 items-center rounded font-semibold  cursor-pointer text-white`}
              >
                {" "}
                <img
                  className="bg-white rounded-full w-12"
                  src="/assets/Payment/pngwing.com (5).png"
                  alt=""
                />
                GPay
              </label>
            </div>
          </div>
          {/* {paymentMethod === "cashOnDelivery" && (

        )} */}
          {paymentMethod === "csreditCard" && (
            <div className="md:flex">
              <div className="bg-white shadow-lg px-6 py-8 md:p-8 w-full">
                <p className="mt-4 mb-6 font-primaryFont font-semibold text-gray-700 underline underline-offset-[4px]">
                  Enter Your Card Details
                </p>
                <form>
                  <div className="mb-6">
                    <label className="block mb-2 text-gray-700">
                      Card Number
                    </label>
                    <input
                      type="text"
                      name="cardNumber"
                      value={formData.cardNumber}
                      onChange={handleInputChange}
                      className="border-gray-300 focus:border-indigo-300 focus:ring-opacity-20 shadow-sm p-2 border rounded-md w-full focus:outline-none focus:ring focus:ring-indigo-200"
                      placeholder="0000 0000 0000 0000"
                    />
                  </div>

                  <div className="flex gap-4 mb-6 w-full">
                    <div className="w-1/2">
                      <label className="text-gray-700">Expiration Date</label>
                      <input
                        type="text"
                        name="expiryDate"
                        value={formData.expiryDate}
                        onChange={handleInputChange}
                        className="border-gray-300 focus:border-indigo-300 focus:ring-opacity-20 shadow-sm p-2 border rounded-md w-full focus:outline-none focus:ring focus:ring-indigo-200"
                        placeholder="MM/YY"
                      />
                    </div>

                    <div className="mb-6 w-1/2">
                      <label className="text-gray-700">CVV</label>
                      <input
                        type="text"
                        name="cvv"
                        value={formData.cvv}
                        onChange={handleInputChange}
                        className="border-gray-300 focus:border-indigo-300 focus:ring-opacity-20 shadow-sm p-2 border rounded-md w-full focus:outline-none focus:ring focus:ring-indigo-200"
                        placeholder="123"
                      />
                    </div>
                  </div>

                  {/* <div>
                  <button
                  onClick={handleSubmit}
                    className="bg-green-500 p-3 w-full font-bold text-gray-100"
                  >
                     Submit Details
                  </button>
                </div> */}
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <button className="bg-blue-500 mt-4 px-4 py-2 rounded text-white">
        Proceed to Payment
      </button> */}
      <div className="bg-PaymentBg h-screen second-container">
        <div className="space-y-4 shadow-md px-4 py-4">
          <div className="cart-item-container text-sm">
            {cartData.map((product, index) => {
              return (
                <div className="flex justify-between items-center font-primaryFont product-card">
                  <div className="flex justify-start items-center gap-2 image-heading-contaienr">
                    <div className="relative border w-[20%] md:w-[20%] lg:w-[10%] image-container">
                      <img
                        src={product.featuredImage.url}
                        alt={product.title}
                      />
                      <span className="top-[-5px] right-[-10px] absolute bg-gray-500 pt-[2px] rounded-full w-[25px] h-[25px] font-semibold text-center text-white">
                        {product.selectedQuantity}
                      </span>
                    </div>
                    <div className="flex flex-col heading">
                      <h2 className="tracking-wider">
                        <b>Name: </b> {product.title.split(" - ")[0]}
                      </h2>
                      <span>
                        <b>Size: </b>
                        {product.selectedSize}
                      </span>
                    </div>
                  </div>
                  <div className="price">
                    <span className="font-semibold capitalize tracking-widest">
                      Rs.
                      {product.variants.nodes[0].price.amount *
                        product.selectedQuantity}
                      {/* Rs.{product.totalValue} */}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex flex-col justify-center items-center gap-2 w-full font-primaryFont text-primary total-container">
            <div className="flex justify-between items-center w-full subtotal">
              <span>Subtotal</span>
              <b className="text-black">{carttotalPrice || 2323}</b>
            </div>
            <div className="flex justify-between items-center w-full shipping">
              <span>Shipping</span>
              <span>On shipping address</span>
            </div>
            <div className="flex justify-between items-center w-full total">
              <b className="text-black">Total</b>
              <span className="font-bold text-black">
                Rs {carttotalPrice || 2323}
              </span>
            </div>
            <div className="flex justify-center items-center w-full pay-button-container">
              <button onClick={handleSubmit}
             
                className="bg-green-500 p-3 w-1/2 font-bold text-gray-100"
              >
                Proceed To Payment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentFinal;
